//new technique, should apply it to everything below


import {
  fragmentsDictHasValue,
  fragmentsSetHasValue,
  inputIsTruthy,
  isAlwaysConsideredPopulatedAndValid,
  linkEmbedWithInputHasValue,
  repeaterHasValue,
  richTextHasValue,
  simpleTableHasValue,
  valueNotFalsyOrEmptyAryObj,
  tagsSelectCompHasValue,
  valueArrayIsNotEmpty,
  valueIsNotUndefined,
  BACKWARDS_COMPAT_lexicalTextEditorHasValue,
  linkHasValue,
  valueIsNotUndefinedOrNullOrEmptyString,
  VALIDATOR_FN_MAP,
} from "./validatorFns";
import { blockRegistry } from "@okf/ootils";

/** validation functions */

/** end validation functions */

export const isPopulatedValidators = (comp, props) => {
  // Registry-driven lookup
  const blockDef = blockRegistry.getBlock(comp);
  if (blockDef) {
    return VALIDATOR_FN_MAP[blockDef.validation.populatedCheckFn];
  }

  switch (comp) {

    case "RadioList":
      return valueIsNotUndefinedOrNullOrEmptyString; //falsy check is not enough cuz, saveValueAsString could return a selected value of 'false'

    case "NumberInput":
      return valueIsNotUndefinedOrNullOrEmptyString; // 0 is a real answer

    case "GroupQuestionsInputSingle":      
    case "DropdownSingle":
    case "ComboboxSingleLanguage":
    case "DropdownSingleLanguage":
    case "TableTags":
      return valueNotFalsyOrEmptyAryObj;

    
    case "DropdownMulti":
    
    case "ProfileImageInput":
    case "ImageInput":
    case "VideoInput":
    case "PDFInput":
    case "CheckboxList":
      return valueArrayIsNotEmpty;
    
    case "TagsInputSingle":
    case "TagsInputMulti":
      return tagsSelectCompHasValue;

    case "Repeater":
    case "RepeaterTabs":
      return repeaterHasValue;

    case "FragmentsSet":
      return fragmentsSetHasValue;

    case "FragmentsDict":
      return fragmentsDictHasValue;

    case "RichTextAsPlainText":
    case "TableTextWithTag":
    case "KPRichInput":
    case "RichTextEditor":
      return richTextHasValue;

    case "SummaryInput":
    case "RichTextAsPlainTextLex": //cuz this comp is backwards compat. i.e it accepts value as either draftjs shape or lexical shape
      return BACKWARDS_COMPAT_lexicalTextEditorHasValue;

    case "TextInput":
    case "TableTextInput":
    case "JSONInput":
    case "PasswordInput":
    case "EmailInput":
    case "PhoneInput":
    case "URLInput":
    case "NumberInput":
    case "Tags__Intro":
    case "SANS_3":
    case "SANS_2":
    case "SANS_0":
    case "DateDisplay":
    case "DateTimeDisplay":
    case "DateTimePicker":
    case "CalcTimePeriodDisplay":
    case "ElapsedDays":
    case "StatusTagOutlineStyle":
    case "StatusTag":
    case "IFrameInput":
    case "CommaSeparatedWords":
    case "UserRoleBadge":
    case "TableText":
    case "TablePill":
    case "TableShareShift": //null when there is no pair to show, so the cell reads "-"
    case "TitleInput":
    case "SubtitleInput":
      return inputIsTruthy;

    case "TableLink": 
      return linkHasValue;

    case "RightWrong":
    case 'SwitchSingle': 
    case 'CheckboxButton': //else a '-' will show in table comp
    case 'TableCheck': //else a '-' will show in table comp
    case "TableCheckPlusDropdown": //else a '-' will show in table comp
    case "TableArrayCount":
    case "TableCountBar": //else a '-' will show in table comp
    case "TablePairDisplay": //else a '-' will show in table comp
    case "TablePercent": //else a '-' will show in table comp
    case "TableStrengthRamp": //else a '-' will show in table comp
    case "TableNumber": //zero is a value here, not an empty cell
    case "TableSpeaker": // the Customers table's row-reading cells: the row is the value
    case "TablePersonas":
    case "TableDatasetsDocuments":
    case "TableChange":
    case "TableSparkline":
    case "TableDatasetCircles":
      return isAlwaysConsideredPopulatedAndValid;

    case "LinkEmbedWithInput":
      return linkEmbedWithInputHasValue;

    case "SimpleTable":
      return simpleTableHasValue;

    default:
      return undefined;
  }
};

export const blockIsPopulatedConditions = (block, value) => {
  let validatorFn = isPopulatedValidators(block.comp, block.props);
  if (validatorFn) {
    return validatorFn(value, block.props);
  } else {
    //deprecated stuff...
    return (
      (value &&
        ((block.comp === "ResourceInput" && value.length > 0) ||
          (block.comp === "KPTagsInput" && value.length > 0) ||
          block.comp === "KPLikeContactChannelsBlock" ||
          (block.comp === "KPLikeOrgAndDesignation" &&
            (value.name.internal.length > 0 ||
              value.name.external.length > 0)) ||
          block.comp === "KPDropdown" ||
          block.comp === "DatePicker" ||
          block.comp === "DateRangePicker" ||
          block.comp === "DateTimeRangePicker" ||
          block.comp === "DynamicRefetchDropdown")) ||
      block.comp === "ButtonTab" ||
      block.comp === "KPMetaPrimary" ||
      block.comp === "TplMetaBlock" ||
      block.comp === "PageIconBlock" ||
      block.comp==="PluginSentinel"  ||
      // block.comp === 'KPCasesDataOverview' ||
      block.comp === "MarkAsCompleteToggle" ||
      block.comp==="InfoText"
    );
  }
};





export const checkIfCardIsPopulated = (cardData) => {
  if (
    cardData &&
    ((cardData.img.imgData && cardData.img.imgData.length > 0) ||
      cardData.nameString.length > 0 ||
      (cardData.desc &&
        cardData.desc.blocks[0] &&
        cardData.desc.blocks[0].text.length > 0) ||
      cardData.selected.length > 0) //basically we are saying, at least 1 field should be populated
  ) {
    return true;
  } else {
    return false;
  }
};
